import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { EMPTY, Observable, of, Subscription, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { UtilService } from '../services/util.service';
import swal from 'sweetalert2';
import { SearchData } from '../services/searchData';
import { environment } from 'src/environments/environment';
import { ApiService } from '../services/api.service';
import { UserService } from '../services/UserService';
import { GigsumoService } from '../services/gigsumoService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService } from '../services/toaster.service';


@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  eventEmitter: Subscription
  isLoggedOut: boolean = false
  public lamdaurl: any = environment.LAMDA_URL;

  constructor(private _router: Router, private util: UtilService, private searchData: SearchData,
    private cookie: CookieService,private api : ApiService,private userService: UserService,
  private gigsumoService: GigsumoService, private ngbModal: NgbModal,
  private toasterService: ToasterService) {
    //
    this.eventEmitter = this.searchData.getCommonVariables().subscribe(res => {
      if (res.isLoggedOut == true) {
        this.isLoggedOut = true
      } else {
        this.isLoggedOut = false
      }
    })
    document.cookie = 'curl=' + window.location.href;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    document.cookie = 'curl=' + window.location.href;
    //document.cookie = 'userId='+localStorage.getItem('userId');
    var header = {};
    const windowLocation = window.location.href.split("?", 1);


    if (req.url.indexOf('https://api.stripe.com/v1/checkout/sessions/') == -1 && req.url.indexOf('https://api.openai.com/v1/chat/completions')==-1) {
      header['curl'] = windowLocation[0];
      header['X-Content-Type-Options'] = 'nosniff';
      if (localStorage.getItem('userId') != null) {
        header['userId'] = localStorage.getItem('userId');
      }

      if (localStorage.getItem('sessionID') != null) {
        header['sessionID'] = this.util.decrypt(localStorage.getItem('sessionID'));

      }
    }




    // if(localStorage.getItem('token') != null){


    if(req.url.indexOf("home/logout")  !== -1 || req.url.indexOf("user/find/sessionData")  !== -1) {

      const session = this.util.decrypt(localStorage.getItem('sessionID'));
      let credentials = btoa(localStorage.getItem("userId") + ":" + session);
      if (session != "" && req.url.indexOf('/findPlans') != 68) {
        header['Authorization'] = 'Basic ' + credentials;
      }
    }
    else if (req.url.indexOf("home/login") == -1 &&
      req.url.indexOf("home/forgot/password") == -1 &&
      req.url.indexOf("user/signup") == -1 &&
      req.url.indexOf("user/invite") == -1 &&
      req.url.indexOf(this.lamdaurl) == -1 &&
      req.url.indexOf('https://api.stripe.com/v1/checkout/sessions/') == -1 &&
      req.url.indexOf('https://api.openai.com/v1/chat/completions') == -1 &&
      req.url.indexOf("user/setPassword") == -1 &&
      req.url.indexOf("user/directory") == -1 &&
      req.url.indexOf("user/actuator") == -1 &&
      req.url.indexOf("user/validateToken") == -1 &&
      req.url.indexOf("user/updateSleepEvent") == -1 &&
      req.url.indexOf("actuator/info") == -1 &&
      req.url.indexOf("home/logout") == -1 &&
      req.url.indexOf("user/findOpenAuthentication/") == -1 &&
      req.url.indexOf("user/createtoken") == -1

    ) {

      const session = this.util.decrypt(localStorage.getItem('sessionID'));
      // let credentials = btoa(localStorage.getItem("userId") + ":" + session);
      if (session != "" && req.url.indexOf('/findPlans') != 68) {
        let token = localStorage.getItem("token");
        if(token){
          header['Authorization'] = 'Bearer ' + token;
        }else {
          this.tokenExpired();
        }
      }
    }

   // console.log(req.url.indexOf('https://api.stripe.com/v1/checkout/sessions/'))

    if (req.url.indexOf('https://api.stripe.com/v1/checkout/sessions/') == 0) {
          header['Content-Type'] = 'application/x-www-form-urlencoded';
    }




    const cloneReq = req.clone({
      withCredentials: true,
      setHeaders: header
    });


return next.handle(cloneReq).pipe(
      tap(evt => {


        if (evt instanceof HttpResponse) {


          //     if(evt.body && evt.body.success)
          //         this.toasterService.success(evt.body.success.message,
          // evt.body.success.title, { positionClass: 'toast-bottom-center' });
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {

          if (err && err.error) {
            var notification = err.url.slice(-18)
            if (err.error.code === 'INVALID_SESSION') {
              if (this.isLoggedOut == true) {
                this.cookie.deleteAll();
                let allCookies = document.cookie.split(';');
                if (allCookies) {
                  for (let i = 0; i < allCookies.length; i++) {
                    document.cookie = allCookies[i] + "=;expires="
                      + new Date(0).toUTCString();
                  }
                }
                localStorage.clear();
                // Session gone — close any body-level NgbModal (e.g. the document
                // upload popup) that would otherwise survive the route change and
                // stay open on top of the login page.
                this.ngbModal.dismissAll();
                // The toaster container is body-level in the same sense: it sits
                // beside the router outlet, so a live toaster rides the redirect.
                this.toasterService.clear();
                this._router.navigate(['/auth/login']);
                this.util.stopLoader();
                swal.close();
                return EMPTY;

              } else if (this.isLoggedOut == false && swal.isVisible() == false) {  //swal.isVisible() == false -> to not show alert when it is already shown
                this.tokenExpired();
              }
              // if(this.route.pathFromRoot[0]['_routerState']['snapshot'].url !== '/login'){
              // //// console.log("this.route.pathFromRoot[0]['_routerState']['snapshot'].url")
              // //// console.log(this.route.pathFromRoot[0]['_routerState']['snapshot'].url)

              // }
            } else if (notification === "notification/query" && err.status === 500) {
              this.util.stopLoader()
            } else if (err.status === 500) {
              // this.util.stopLoader()
              return throwError(err)
            } else if (err.status === 0) {
              this.util.stopLoader()
              return throwError(err)
            } else if (err.status === 401) {
              this.util.stopLoader()
              this.tokenExpired();
              return throwError(err)
            } else if (err.status === 403) {
              this.util.stopLoader()
              this.tokenExpired();
              return throwError(err)
            } else if (err.status !== 200) {
              this.util.stopLoader()
              return throwError(err)
            }





            // //// console.log(this.route.pathFromRoot[0]['_routerState']['snapshot'].url)
            // //// console.log("this.route.parent.snapshot.url")
            // else if(err.status != 200){
            //   this.util.stopLoader();
            //   // swal.fire({
            //   //   title: '<strong>ERROR Reports</strong>',
            //   //   icon: 'error',
            //   //   text: err.statusText,
            //   //   focusConfirm: true,
            //   //   confirmButtonText: 'Ok',
            //   //   confirmButtonAriaLabel: 'Ok',
            //   // });

            //   swal.fire({
            //     icon: "error",
            //     title: "ERROR Reports",
            //     showConfirmButton: true,
            //     timer: 1500,
            //   });


            // }
          }

        }

        return of(err);
      }));
  }

  tokenExpired(){
    if(swal.isVisible()){
      return;
    }

    if (this._router.url.includes('/auth/login')) {
      return;
    }

    // Keep the screen clean while the dialog counts down. Anything raised
    // during those 3 seconds is cleared again by onLogoutSuccess(). The sockets
    // are deliberately NOT torn down here: this runs on any 401/403, and a
    // closed socket in this app never re-opens by itself, so doing it here left
    // a still-valid session with no notifications at all.
    this.toasterService.clear();

    swal.fire({
      icon: "info",
      title: "Invalid session",
      text: "Sorry, your session has expired. We are routing you to login page.",
      showConfirmButton: false,
      timer: 3000,
    }).then(() => {
      this.logout();
      swal.close();
      return EMPTY;
    });
  }

  logout(){
    this.api.onLogout().subscribe((res) => {
      if (res) {
        if (res.code === "00000") {
          this.util.stopLoader();
          this.gigsumoService.clearCache();
          this.userService.onlineAPI('OFFLINE');
          this.onLogoutSuccess();
        } else {
          this.util.stopLoader();
        }
      }
    });
  }

  onLogoutSuccess() {
    this.cookie.deleteAll();
    let allCookies = document.cookie.split(";");
    if (allCookies) {
      for (let i = 0; i < allCookies.length; i++) {
        document.cookie = allCookies[i] + "=;expires=" + new Date(0).toUTCString();
      }
    }
    localStorage.clear();
    // Close any body-level NgbModal (e.g. the document upload popup) before
    // routing to login — modals are attached to <body>, outside the router
    // outlet, so they persist across navigation unless explicitly dismissed.
    this.ngbModal.dismissAll();
    // Same reasoning for the toaster container: it is rendered next to the
    // router outlet in app.component.html, never destroyed by a navigation, so
    // a toaster raised moments ago keeps running out its duration on top of the
    // login form unless it is dropped explicitly.
    this.toasterService.clear();
    this._router.navigate(["/auth/login"]);
  }

}
